import React from 'react'
import { HotelSearchFilters, HotelSearchFormProps } from '../Types/hotelTypes';
import SearchFormWrapper, { FieldConfig, SearchFormTypes } from '../../Shared/Components/SearchFormWrapper';

const HotelSearchForm = ({ onSearch }: HotelSearchFormProps) => {
    const [filters, setFilters] = React.useState<HotelSearchFilters>({
        name: "",
        published: ""

    });


    const fields: FieldConfig[] = [
        { name: "name", label: "Nazwa hotelu", type: SearchFormTypes.input, value: "" },

        {
            name: "published",
            label: "Opublikowany",
            type: SearchFormTypes.select,
            options: [
                { id: "true", name: "Tak" },
                { id: "false", name: "Nie" },
            ],
        },
    ];

    const handleSearch = (values: Record<string, string>) => {
        setFilters(values as unknown as HotelSearchFilters);
        onSearch({
            name: values.name,
            published:
                values.published === ""
                    ? ""
                    : values.published === "true"
                        ? "true"
                        : "false",
        });
    };

    return (
        <SearchFormWrapper
            fields={fields}
            initialValues={filters as unknown as Record<string, string>}
            onSubmit={handleSearch}
        />
    );
}
export default HotelSearchForm